import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f51da6d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "otp-group" }
const _hoisted_2 = ["maxlength", "value", "onInput"]

import { computed } from "vue";


export const REG_INPUTVALUE = new RegExp(/^[A-Za-z0-9_.]+$/);

export default /*#__PURE__*/_defineComponent({
  props: {
  value: {
    type: String,
  },
  valueLength: {
    type: Number,
    default: 4,
  },
},
  emits: ["onChange"],
  setup(__props, { emit }: { emit: ({
  (e: "onChange", value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props





const valueItems = computed(() => {
  const items = [];
  const valueArray = props.value.split("");
  for (var i = 0; i < props.valueLength; i++) {
    const char = valueArray[i];
    if (REG_INPUTVALUE.test(char)) {
      items.push(char);
    } else {
      items.push("");
    }
  }
  return items;
});

const focusToNextInput = (target: HTMLElement) => {
  const nextElementSibling =
    target.nextElementSibling as HTMLInputElement | null;

  if (nextElementSibling) {
    nextElementSibling.focus();
  }
};

const focusToPrevInput = (target: HTMLElement) => {
  const previousElementSibling =
    target.previousElementSibling as HTMLInputElement | null;

  if (previousElementSibling) {
    previousElementSibling.focus();
  }
};

const inputOnChange = (e, idx: number) => {
  const target = e.target;
  let targetValue = target.value.trim();
  if (targetValue.length > props.valueLength) {
    targetValue.substring(0, props.valueLength)
  }
  const isTargetValueDigit = REG_INPUTVALUE.test(targetValue);

  if (!isTargetValueDigit && targetValue !== "") {
    return;
  }

  const nextInputEl = target.nextElementSibling as HTMLInputElement | null;

  // only delete digit if next input element has no value
  if (!isTargetValueDigit && nextInputEl && nextInputEl.value !== "") {
    return;
  }

  targetValue = isTargetValueDigit ? targetValue : " ";

  const targetValueLength = targetValue.length;

  if (targetValueLength === 1) {
    const newValue = props.value.substring(0, idx) + targetValue + props.value.substring(idx + 1);

    onChange(newValue);

    if (!isTargetValueDigit) {
      return;
    }

    focusToNextInput(target);
  } else if (targetValueLength === props.valueLength) {
    onChange(targetValue);

    target.blur();
  }
};

const onChange = (value: string) => {
  emit("onChange", value);
};

const inputOnKeyDown = (e) => {
  const { key } = e;
  const target = e.target as HTMLInputElement;

  if (key === "ArrowRight" || key === "ArrowDown") {
    e.preventDefault();
    return focusToNextInput(target);
  }

  if (key === "ArrowLeft" || key === "ArrowUp") {
    e.preventDefault();
    return focusToPrevInput(target);
  }

  const targetValue = target.value;

  // keep the selection range position
  // if the same digit was typed
  target.setSelectionRange(0, targetValue.length);

  if (e.key !== "Backspace" || targetValue !== "") {
    return;
  }

  focusToPrevInput(target);
};

const inputOnFocus = (e) => {
  const { target } = e;

  // keep focusing back until previous input
  // element has value
  const prevInputEl = target.previousElementSibling as HTMLInputElement | null;

  if (prevInputEl && prevInputEl.value === "") {
    return prevInputEl.focus();
  }

  // target.setSelectionRange(0, target.value.length);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(valueItems), (item, idx) => {
      return (_openBlock(), _createElementBlock("input", {
        key: idx,
        type: "text",
        autocomplete: "one-time-code",
        size: "1",
        maxlength: __props.valueLength - idx,
        class: "otp-input",
        placeholder: "_",
        value: item,
        onInput: ($event: any) => (inputOnChange($event, idx)),
        onKeydown: inputOnKeyDown,
        onFocus: inputOnFocus
      }, null, 40, _hoisted_2))
    }), 128))
  ]))
}
}

})